import React, { useState } from 'react';
import { FormEvent } from 'react';
import { MapPinIcon, SearchIcon } from 'lucide-react';
import { pharmacies } from '../lib/platformData';
import { PillarMatrix } from '../components/PillarMatrix';
type ResultsPageProps = {
  search: string;
  onSearch: (query: string) => void;
  onSelect: (id: string) => void;
};
export function ResultsPage({
  search,
  onSearch,
  onSelect
}: ResultsPageProps) {
  const [query, setQuery] = useState(search);
  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (query.trim()) onSearch(query.trim());
  }
  return <main className="min-h-[calc(100vh-4rem)] bg-[#F7F7F7]" data-id="element-407" data-mp="14q59bu75zyza">
      <div className="mx-auto grid w-full min-h-[calc(100vh-4rem)] lg:grid-cols-[minmax(0,1fr)_42%]" data-id="element-408" data-mp="14rq5fo94npz9">
        <section className="bg-white lg:max-h-[calc(100vh-4rem)] lg:overflow-y-auto" data-id="element-409" data-mp="19qt9p6ha9s66">
          <div className="space-y-4 border-b border-gray-100 px-4 py-6 sm:px-8" data-id="element-410" data-mp="3pejks8ic4f1e">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#A63A2B]" data-id="element-411" data-mp="3ufquwe7y9qb8">
              Find a pharmacy near you
            </p>
            <form onSubmit={submit} className="flex w-full max-w-md items-center overflow-hidden rounded-lg border border-gray-200 bg-white pl-3 shadow-sm focus-within:border-[#1C1C1C] focus-within:ring-2 focus-within:ring-[#1C1C1C]/10" data-id="element-412" data-mp="3tuoo04rbxwzd">
              <label htmlFor="results-search" className="sr-only" data-id="element-413" data-mp="6s22bdh70w3u">
                Search by pharmacy name or ZIP code
              </label>
              <input id="results-search" value={query} onChange={event => setQuery(event.target.value)} className="w-full min-w-0 py-3 text-sm text-gray-700 outline-none placeholder:text-gray-400" placeholder="Search by name or zip code" data-id="element-414" data-mp="gool7wpyld38" />
              <button type="submit" className="bg-[#1C1C1C] px-6 py-3 text-sm font-semibold text-white hover:bg-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#A63A2B]" data-id="element-415" data-mp="14e93edeag6bg">
                Search
              </button>
            </form>
            <p className="mt-3 flex items-center gap-1.5 text-xs text-[#777]" data-id="element-416" data-mp="1bh7aheoz3paq">
              <MapPinIcon className="h-3.5 w-3.5" data-id="element-417" data-mp="1gf8sdwanxikm" /> Pharmacies currently active
              in Chicago, Illinois
            </p>
          </div>
          <div className="space-y-4 px-4 py-5 sm:px-8" data-id="element-418" data-mp="1l8jz7xfh5zcj">
            <div className="flex items-end justify-between" data-id="element-419" data-mp="1q523kw6w7voc">
              <div data-id="element-420" data-mp="1u6w1iwppelkt">
                <h1 className="text-xl font-black tracking-tight text-[#1C1C1C]" data-id="element-421" data-mp="1u6dx3csw111t">
                  Local pharmacy results
                </h1>
                <p className="mt-1 text-sm text-[#777]" data-id="element-422" data-mp="1z4fcnnr3ui8j">
                  Compare what changes your day.
                </p>
              </div>
              <p className="text-xs font-bold text-[#777]" data-id="element-423" data-mp="4tafn2aix426">
                {pharmacies.length} results
              </p>
            </div>
            <div className="hidden grid-cols-[minmax(0,1fr)_240px] border-b border-[#DCDCDC] px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-[#777] sm:grid" data-id="element-424" data-mp="9ru3x9clarxp">
              <span data-id="element-425" data-mp="3tlyng2jztatf">Pharmacy</span>
              <div className="grid grid-cols-3 text-center" data-id="element-426" data-mp="3tknku62aa93w">
                <span className="text-[#1C1C1C]" data-id="element-427" data-mp="3oooyeo0in164">Stock</span>
                <span className="text-[#B46423]" data-id="element-428" data-mp="3joswqvfajltq">Wait</span>
                <span className="text-[#1C1C1C]" data-id="element-429" data-mp="3jqdsuph97ctp">Care</span>
              </div>
            </div>
            <div data-id="element-430" data-mp="l6f0tmdtuqnc">
              {pharmacies.map(pharmacy => <button key={pharmacy.id} type="button" onClick={() => onSelect(pharmacy.id)} className="flex w-full items-center gap-4 border-b border-[#E5E5E5] px-3 py-5 text-left hover:bg-[#FCF8F7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#A63A2B]" data-id="element-431" data-mp="g7ki0kfv1238">
                  <div className="min-w-0 flex-1" data-id="element-432" data-mp="2qzlylxjr0y90">
                    <p className="truncate text-base font-black text-[#1C1C1C]" data-id="element-433" data-mp="2r1zto6efiagk">
                      {pharmacy.name}
                    </p>
                    <p className="mt-1 text-xs font-medium text-[#8A8A8A]" data-id="element-434" data-mp="ofn8or3fatv6">
                      {pharmacy.category} · {pharmacy.neighborhood}
                    </p>
                    <p className="mt-2 text-xs text-[#777] sm:hidden" data-id="element-435" data-mp="9oo5xwp9qzji">
                      Stock {pharmacy.scores.stock.toFixed(1)} ·{' '}
                      <span className="text-[#B46423]" data-id="element-436" data-mp="12g7rhn9c8poo">
                        Wait {pharmacy.scores.wait.toFixed(1)}
                      </span>{' '}
                      · Care {pharmacy.scores.care.toFixed(1)}
                    </p>
                  </div>
                  <div className="hidden sm:block" data-id="element-437" data-mp="xg37vod4veu8">
                    <PillarMatrix scores={pharmacy.scores} compact data-id="element-438" data-mp="xes9y56dd1b1" />
                  </div>
                </button>)}
            </div>
          </div>
        </section>
        <aside className="relative hidden overflow-hidden bg-[#EFEDEA] lg:block" aria-label="Map of nearby pharmacy results" data-id="element-439" data-mp="3i7di1t7z6nlu">
          <div aria-hidden="true" className="absolute inset-0 opacity-70 [background-image:linear-gradient(25deg,transparent_47%,#d9d5d0_48%,#d9d5d0_50%,transparent_51%),linear-gradient(115deg,transparent_47%,#e1ddd9_48%,#e1ddd9_50%,transparent_51%)] [background-size:150px_120px]" data-id="element-440" data-mp="20aifikw6z76e" />
          <div className="absolute left-[16%] top-[22%] h-[38%] w-[58%] rotate-[-12deg] border-x border-[#D3CFC9]" data-id="element-441" data-mp="1hhy30e0sveor" />
          <div className="absolute left-8 top-8 bg-white px-3 py-2 text-xs font-bold text-[#1C1C1C] shadow-sm" data-id="element-442" data-mp="1cjwbd4pb671o">
            Chicago · {pharmacies.length} pharmacies
          </div>
          {pharmacies.map((pharmacy, index) => <button key={pharmacy.id} type="button" onClick={() => onSelect(pharmacy.id)} className="absolute grid h-9 w-9 place-items-center rounded-full bg-[#A63A2B] text-sm font-black text-white shadow-lg hover:bg-[#8D3024] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#A63A2B] focus-visible:ring-offset-2" style={{
          left: `${23 + index * 16}%`,
          top: `${36 + index % 2 * 24}%`
        }} aria-label={`View ${pharmacy.name}`} data-id="element-443" data-mp="1li86nk14dt0g" data-mpi={index}>
              {index + 1}
            </button>)}
        </aside>
      </div>
    </main>;
}